module.exports = __webpack_public_path__ + "img/message.5de13e58.svg";